export const stripNewLines = (content: string) => content.replace(/^\n+|(\n+|\\)+$/g, '');
